export default __webpack_public_path__ + "static/media/car.0bcdf10a.png";